<template>
  <div class="video">

    <transition name="hideShow">
      <Alert
        :alertTypeFn="alertTypeFn"
        v-if="alertType"
      />
    </transition>
    <Logo />
    <video
      ref="video"
      :src="src[0]"
      :poster="src[1]"
      webkit-playsinline="true"
      playsinline=""
      preload="auto"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
    ></video>
    <transition name="hideShow">
      <Problem
        v-if="btnType"
        :handleBtnClick="handleBtnClick"
        :loopIndex="loopIndex"
        :alertTypeFn="alertTypeFn"
      />
    </transition>
  </div>
</template>

<script>
import Logo from "../logo";
import Problem from "./components/problem";
import { mapActions } from "vuex";
import Alert from "./components/alert";
export default {
  name: "VideoCom",
  components: {
    Logo,
    Problem,
    Alert
  },
  data() {
    return {
      pc: [
        "https://n.v.netease.com/2019/0307/v.mp4",
        require("@/assets/video/poster.jpg")
      ],
      mb: [
        "https://n.v.netease.com/2019/0307/mv.mp4",
        require("@/assets/video/mposter.jpg")
      ],

      //  4~7
      // 11~14
      // 18~21
      // 26~32
      // 38~44
      // 48~50
      // 54~60
      //循环开始点
      //循环结束点
      loopNode: [
        [4.2, 6.2],
        [11.2, 13.7],
        [19, 20.7],
        [26.4, 31.7],
        [38.2, 43.6],
        [48, 49.8],
        [54.2, 59.8]
      ],
      loopIndex: 0, // 记录做到了第几题
      btnType: false, // 选择题模块
      alertType: false
    };
  },
  computed: {
    src() {
      return this.$store.state.dev ? this.mb : this.pc;
    }
  },
  mounted() {
    // 进度条改变事件
    this.$refs.video.addEventListener("timeupdate", this.timeupdate);

    // 视频播放完成后触发事件
    this.$refs.video.addEventListener("ended", this.handleEnded);

    // 把视频对象抛到全局
    this.videoObjFn(this.$refs.video);
  },
  methods: {
    ...mapActions(["videoObjFn", "videoComFn", "resVideoFn", "lastShowFn"]),
    timeupdate() {
      let ele = this.$refs.video;
      // 卡住循环点
      if (this.loopIndex < this.loopNode.length) {
        if (ele.currentTime >= this.loopNode[this.loopIndex][1]) {
          ele.currentTime = this.loopNode[this.loopIndex][0];
        }
        // 按钮出现区间
        if (
          ele.currentTime >= this.loopNode[this.loopIndex][0] &&
          ele.currentTime <= this.loopNode[this.loopIndex][1]
        ) {
          this.btnType = true; // 出现选择题模块
        }
      }
    },
    // 问题选择后
    handleBtnClick() {
      // 以下这句代码的意思是：点击选项后直接跳到循环结束点进行播放
      this.$refs.video.currentTime = this.loopNode[this.loopIndex][1];

      this.loopIndex++;
      this.btnType = false;
    },
    // 视频播放完触发
    handleEnded() {
      // 隐藏视频组件
      this.videoComFn(false);
      // 显示数据组件
      this.resVideoFn(true);

      // 显示结果last组件show none
      this.lastShowFn(true);
    },
    // 弹窗
    alertTypeFn(t) {
      this.alertType = t;
    }
  }
};
</script>

<style lang="scss" scoped>
.hideShow-leave-active,
.hideShow-enter-active {
  transition: all 0.5s ease;
}
.hideShow-leave-to,
.hideShow-enter {
  opacity: 0;
}
.hideShow-leave,
.hideShow-enter-to {
  opacity: 1;
}
@import "~@/assets/styles/com.scss";
.video {
  position: absolute;
  top: 0;
  left: 0;
  @include wh(100%, 100%);

  video {
    display: block;
    @include wh(100%, 100%);
    object-fit: cover;
  }
}
</style>


